import { getPath } from "@libry-content/common";
import { Translate } from "../../utils/hooks/useTranslation";

export const grades = ["trinn1", "trinn2", "trinn3", "trinn4", "trinn5", "trinn6", "trinn7", "trinn8"] as const;
export type Grade = (typeof grades)[number];
export const isGrade = (grade?: string): grade is Grade => typeof grade === "string" && grades.includes(grade as Grade);
export type SommerlesPopularReadingResponse = Record<Grade, string[]>;

export const getGradePath = (grade: Grade) => {
  return `${getPath({ _type: "sommerles", _id: "" })}/${grade}`;
};

export const getGradeLabel = (grade: Grade, t: Translate["t"]) => {
  switch (grade) {
    case "trinn1":
      return `${t("første")} ${t("trinn")}`;
    case "trinn2":
      return `${t("andre")} ${t("trinn")}`;
    case "trinn3":
      return `${t("tredje")} ${t("trinn")}`;
    case "trinn4":
      return `${t("fjerde")} ${t("trinn")}`;
    case "trinn5":
      return `${t("femte")} ${t("trinn")}`;
    case "trinn6":
      return `${t("sjette")} ${t("trinn")}`;
    case "trinn7":
      return `${t("syvende")} ${t("trinn")}`;
    case "trinn8":
      return `${t("åttende")} ${t("trinn")}`;
  }
};

export const getSommerlesPopularReading = async (): Promise<SommerlesPopularReadingResponse | undefined> => {
  try {
    const response = await fetch(`https://sommerles.no/api/v1/popularByGrade`);

    if (!response.ok) throw new Error();

    const data = await response.json();

    return data;
  } catch (error) {
    console.error("Error fetching Sommerles popular reading data: ", error);
    return undefined;
  }
};
